import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { AssessmentTopic } from '../../interfaces/career-setup/assessment-topic.interface';
import { PageResponse } from '../../interfaces/page-response.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';

export abstract class AssessmentTopicService extends BaseService<AssessmentTopic> {
  abstract override findAll(params: CommonSearchParam): Observable<PageResponse<AssessmentTopic>>;
  abstract override find(id: string): Observable<AssessmentTopic>;
  abstract override create(data: Partial<AssessmentTopic>): Observable<AssessmentTopic>;
  abstract override update(id: string, data: Partial<AssessmentTopic>): Observable<AssessmentTopic>;
  abstract updateStatus(id: string, isActive: boolean): Observable<AssessmentTopic>;
  abstract override delete(id: string): Observable<void>;
}
